import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentStep: 1,
  totalSteps: 5,
  
  // Registration data (temporary)
  registrationData: null,
  
  // OTP data
  otpData: {
    phone: null,
    expiresAt: null,
    resendCooldown: 0,
  },
  
  // Documents
  documents: [],
  
  // Bank details
  bankDetails: null,
  
  // Onboarding status
  status: {
    onboarding_status: 'pending',
    phoneVerified: false,
    documentsUploaded: false,
    bankDetailsCompleted: false,
    canSubmit: false,
  },
  
  loading: false,
  error: null,
};

const sellerOnboardingSlice = createSlice({
  name: 'sellerOnboarding',
  initialState,
  reducers: {
    // Set current step
    setStep: (state, action) => {
      state.currentStep = action.payload;
    },

    // Store registration data temporarily
    setRegistrationData: (state, action) => {
      state.registrationData = action.payload;
    },

    // Set OTP data
    setOTPData: (state, action) => {
      state.otpData = {
        ...state.otpData,
        ...action.payload,
      };
    },

    // Start resend cooldown
    startResendCooldown: (state, action) => {
      state.otpData.resendCooldown = action.payload; // seconds
    },

    // Decrement cooldown
    decrementCooldown: (state) => {
      if (state.otpData.resendCooldown > 0) {
        state.otpData.resendCooldown--;
      }
    },

    // Set documents
    setDocuments: (state, action) => {
      state.documents = action.payload;
    },

    // Add single document
    addDocument: (state, action) => {
      state.documents.push(action.payload);
    },

    // Remove document
    removeDocument: (state, action) => {
      state.documents = state.documents.filter(
        doc => doc.id !== action.payload
      );
    },

    // Set bank details
    setBankDetails: (state, action) => {
      state.bankDetails = action.payload;
    },

    // Set onboarding status
    setStatus: (state, action) => {
      state.status = {
        ...state.status,
        ...action.payload,
      };
    },

    // Set loading
    setLoading: (state, action) => {
      state.loading = action.payload;
    },

    // Set error
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },

    // Clear error
    clearError: (state) => {
      state.error = null;
    },

    // Reset onboarding state
    resetOnboarding: () => initialState,
  },
});

export const {
  setStep,
  setRegistrationData,
  setOTPData,
  startResendCooldown,
  decrementCooldown,
  setDocuments,
  addDocument,
  removeDocument,
  setBankDetails,
  setStatus,
  setLoading,
  setError,
  clearError,
  resetOnboarding,
} = sellerOnboardingSlice.actions;

// Selectors
export const selectOnboarding = (state) => state.sellerOnboarding;
export const selectCurrentStep = (state) => state.sellerOnboarding.currentStep;
export const selectOTPData = (state) => state.sellerOnboarding.otpData;
export const selectDocuments = (state) => state.sellerOnboarding.documents;
export const selectOnboardingStatus = (state) => state.sellerOnboarding.status;

export default sellerOnboardingSlice.reducer;